const SPACING = 16;

export { SPACING };
